import { z } from 'zod';

export const buildEvidenceFieldSchema = (field) => {
  if (Object.hasOwn(field, 'const')) {
    return z.literal(field.const);
  }
  if (field.enum) {
    return z.enum(field.enum);
  }
  if (field.type === 'boolean') {
    return z.boolean();
  }
  if (field.type === 'integer') {
    return z
      .number()
      .int()
      .min(field.minimum ?? 0)
      .max(field.maximum ?? Number.MAX_SAFE_INTEGER);
  }
  if (field.type === 'stringArray') {
    return z
      .array(z.string().trim().min(1))
      .min(field.minItems ?? 1)
      .refine((values) => new Set(values).size === values.length, 'Evidence references must be distinct.');
  }
  if (field.type === 'string') {
    return z.string().trim().min(1);
  }
  throw new Error(`Unsupported app flaw evidence type: ${field.type}`);
};
